<template>
    <div id="Reservation">
      <div  class="social-nav filter-blur-50 border-bottom-white-1-50" >
        <div class="nameContainer" style="width: 100vw">
          <router-link to="/personal" class="d-flex">
            <div class="homeIcon">
              <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
            </div>
          </router-link>
          <!--        <div class="arrowIcon">-->
          <!--          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">-->
          <!--        </div>-->
          <!--        <router-link to="/roaming" class="d-flex">-->
          <!--          <div class="bundleTitle">-->
          <!--            {{digiltaTitle}}-->
          <!--          </div>-->
          <!--        </router-link>-->
          <div class="arrowIcon">
            <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
          </div>
          <div class="titleName">{{$t('reserveNumber.mainTitle')}}</div>
        </div>
      </div>
      <div class="mainContiner">
                  <div class="mtnBack">
                    <router-link to="/reserve-number">
                      <a>
                      <img src="../../assets/icons/reservationBack.svg" style="cursor: pointer" class="back">
                      </a>
                    </router-link>
                  </div>
        <div class="background">
          <div class="NumberReserved d-flex justify-content-center align-items-center">
            <div class="reserveTitle">{{$t('reserveNumber.reserve')}}:</div> <div class="number">{{numberReserved}}</div>
          </div>
          <div class="numberPrice" v-if="lang === 'en'">
            For Only 610 S.P
          </div>
          <div class="numberPrice" v-if="lang === 'ar'">
            610 ل.س فقط
          </div>
          <div class="description">
            {{$t('reserveNumber.formTitle')}}
          </div>
          <div class="formContainer">
            <div class="formImage bigForm">
            <img src="../../assets/icons/reserveForm.svg" class="formImage" style="opacity: 70%">
            <div class="form">
              <div class="row">
                <div class="col-6 validationMargin ">
                  <div class="yellowBorder">
                   <input type="text" :placeholder="this.$t('reserveNumber.firstName')" v-model="firstName" @input="nameValidation">
                  </div>
                  <span class="validationMessage"><small  v-if="submited">{{nameError}}</small></span>
                </div>
                <div class="col-6 validationMargin">
                  <div class="yellowBorder">
                    <input type="text" :placeholder="this.$t('reserveNumber.familyName')" v-model="familyName" @input="familyValidation">
                  </div>
                  <span class="validationMessage" ><small v-if="submited">{{familyError}}</small></span>
                </div>
              </div>
              <div class="row">
                <div class="col-6 validationMargin">
                  <div class="yellowBorder">
                    <input type="text" :placeholder="this.$t('reserveNumber.father')" v-model="fatherName" @input="fatherValidation">
                  </div>
                  <span class="validationMessage"><small v-if="submited">{{fatherError}}</small></span>
                </div>
                <div class="col-6 validationMargin">
                  <div class="yellowBorder">
                    <Dropdown
                      v-model="selectedCity"
                      :options="cities"
                      optionLabel="name"
                      :placeholder="this.$t('reserveNumber.citeName')"
                      @change="cityValidation"
                      @input="getId"
                    />
                  </div>
                  <span class="validationMessage"><small  v-if="submited" >{{cityError}}</small></span>
                </div>
              </div>
              <div class="row">
                <div class="col-12 validationMargin">
                  <div class="yellowBorder">
                    <input type="text" :placeholder="this.$t('reserveNumber.email')" v-model="email" @input="emailValidation">
                  </div>
                  <span class="validationMessage" ><small v-if="submited">{{emailError}}</small></span>
                </div>
              </div>
              <div class="row">
                <div class="col-12 validationMargin">
                  <div class="yellowBorder">
                    <input type="text" :placeholder="this.$t('reserveNumber.anMobail')"  v-model="mobile" @input="mobileValidation">
                  </div>
                  <span class="validationMessage"><small v-if="submited">{{mobileError}}</small></span>
                </div>
              </div>
              <div class="row">
                <div class="col-12 validationMargin">
                  <div class="yellowBorder">
                      <Calendar
                        v-model="date"
                        dateFormat="yy-mm-dd"
                        inputId="birth_date"
                        class="datePicker "
                        :class="[this.$lang === 'ar' ? 'arabicDir' : 'enDir']"
                        :manualInput="false"
                        :maxDate="maxDate"
                        :selectOtherMonths="true"
                      @input="birthdateValidation"/>
                    <label for="birth_date" class="position-absolute labelDate" v-if="date === null">{{$t('reserveNumber.birthdate')}}</label>
                  </div>
                  <span class="validationMessage" ><small  v-if="submited">{{dateError}}</small></span>
                </div>
              </div>
            </div>
              <button class="yellow-button flex-center" @click="submit" >
                <div class="white-blur"></div>
                <div v-if="isLoading" class="spinner-border text-light" role="status"></div>
                <img v-if="!isLoading" class="inner_arrow" src="../../assets/icons/buttonArrow.svg">
                <span v-if="!isLoading" class="read-more submit" :class="[this.$lang === 'ar' ? 'arBtn' : '']">{{$t('feedBack.submit')}}</span>
              </button>
            </div>
            <div class="formImage smallForm ">
              <img src="../../assets/icons/reservationFormSmall.svg" class="formImage" style="opacity: 70%">
              <div class="form">
                <div class="row">
                  <div class="col-12 validationMargin ">
                    <div class="yellowBorder">
                      <input type="text" :placeholder="this.$t('reserveNumber.firstName')" v-model="firstName" @input="nameValidation">
                    </div>
                    <span class="validationMessage"><small  v-if="submited">{{nameError}}</small></span>
                  </div>
                  <div class="col-12 validationMargin">
                    <div class="yellowBorder">
                      <input type="text" :placeholder="this.$t('reserveNumber.familyName')" v-model="familyName" @input="familyValidation">
                    </div>
                    <span class="validationMessage" ><small v-if="submited">{{familyError}}</small></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 validationMargin">
                    <div class="yellowBorder">
                      <input type="text" :placeholder="this.$t('reserveNumber.father')" v-model="fatherName" @input="fatherValidation">
                    </div>
                    <span class="validationMessage"><small v-if="submited">{{fatherError}}</small></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 validationMargin">
                    <div class="yellowBorder">
                      <input type="text" :placeholder="this.$t('reserveNumber.email')" v-model="email" @input="emailValidation">
                    </div>
                    <span class="validationMessage" ><small v-if="submited">{{emailError}}</small></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 validationMargin">
                    <div class="yellowBorder">
                      <input type="text" :placeholder="this.$t('reserveNumber.anMobail')"  v-model="mobile" @input="mobileValidation">
                    </div>
                    <span class="validationMessage"><small v-if="submited">{{mobileError}}</small></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 validationMargin">
                    <div class="yellowBorder">
                      <Calendar
                        v-model="date"
                        dateFormat="yy-mm-dd"
                        inputId="birth_date"
                        class="datePicker "
                        :class="[this.$lang === 'ar' ? 'arabicDir' : 'enDir']"
                        :manualInput="false"
                        :selectOtherMonths="true"
                        :maxDate="maxDate"
                        @input="birthdateValidation"/>
                      <label for="birth_date" class="position-absolute labelDate" v-if="date === null">{{$t('reserveNumber.birthdate')}}</label>
                    </div>
                    <span class="validationMessage" ><small  v-if="submited">{{dateError}}</small></span>
                  </div>
                  <div class="col-6 validationMargin">
                    <div class="yellowBorder">
                      <Dropdown
                        v-model="selectedCity"
                        :options="cities"
                        optionLabel="name"
                        :placeholder="this.$t('reserveNumber.citeName')"
                        @change="cityValidation"
                        @input="getId"
                      />
                    </div>
                    <span class="validationMessage"><small  v-if="submited" >{{cityError}}</small></span>
                  </div>
                </div>
              </div>
              <button class="yellow-button flex-center" @click="submit" >
                <div class="white-blur"></div>
                <div v-if="isLoading" class="spinner-border text-light" role="status"></div>
                <img v-if="!isLoading" class="inner_arrow" src="../../assets/icons/buttonArrow.svg">
                <span v-if="!isLoading" class="read-more submit" :class="[this.$lang === 'ar' ? 'arBtn' : '']">{{$t('feedBack.submit')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Dropdown from 'primevue/dropdown'
import $ from 'jquery'
import ms from '../../utils/messeging'
import ReserveRepositiory from '../../repositories/ReserveRepositiory'
import Calendar from 'primevue/calendar'
import { ref } from 'vue'
import { addDays } from 'date-fns'
import CitiesRepository from '../../repositories/ReservationCitiesRepository'
export default {
  name: 'index',
  components: { Dropdown, Calendar },
  data () {
    return {
      lang: this.$lang,
      date: null,
      citiesRepo: new CitiesRepository(),
      reserve: new ReserveRepositiory(),
      numberReserved: localStorage.getItem('ReservedNumber'),
      isLoading: false,
      firstName: '',
      nameError: '',
      familyName: '',
      familyError: '',
      fatherName: '',
      fatherError: '',
      email: '',
      emailError: '',
      mobile: '',
      mobileError: '',
      submited: false,
      selectedCity: null,
      cityError: '',
      cities: [],
      cityId: '',
      birthDate: ref(),
      dateError: '',
      lineType: localStorage.getItem('typeForReserve'),
      finalDate: '',
      maxDate: null,
      minDate: null
    }
  },
  created () {
    const today = new Date()
    this.maxDate = today
  },
  mounted () {
    this.arabic()
    this.fetchCities()
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        $('.mainContiner, #Reservation .social-nav').css('direction', 'rtl')
        $('.reserveTitle').css('padding', '0 0 0 25px')
        $('.reserveTitle, .description, .yellow-button .read-more').css('font-family', 'mtn-arabic-regular')
        $('.formContainer, .form, .yellow-button .read-more, .mtnBack, .arrowIcon').css('transform', 'rotateY(180deg)')
        $('.yellow-button .read-more').css('right', 'calc(50% - 10px)')
        $('#Reservation .titleName, #Reservation .p-placeholder, .labelDate, .numberPrice').css('font-family', 'mtn-arabic-bold')
        $(' #Reservation .form input').addClass('arabicPlaceholder')
        $('.datePicker').addClass('arabicDir')
      } else if (this.$lang === 'en') {
        $('.reserveTitle').css('padding', '0 25px 0 0')
      }
    },
    async fetchCities () {
      try {
        const response = await this.citiesRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.cities.push({ name: response.data[i].name, code: response.data[i].id })
          }
        }
      } catch (e) {
      }
    },
    nameValidation () {
      const firstName = /^[a-zA-Z\u0600-\u06FF\s]+$/
      if (this.firstName === '') {
        this.nameError = this.$t('reserveNumber.Name')
        return false
      } else if (firstName.test(this.firstName) === false) {
        this.nameError = this.$t('reserveNumber.NameValid')
      } else {
        this.nameError = ''
        return true
      }
    },
    familyValidation () {
      const familyName = /^[a-zA-Z\u0600-\u06FF\s]+$/
      if (this.familyName === '') {
        this.familyError = this.$t('reserveNumber.Name')
        return false
      } else if (familyName.test(this.familyName) === false) {
        this.familyError = this.$t('reserveNumber.NameValid')
      } else {
        this.familyError = ''
        return true
      }
    },
    fatherValidation () {
      const fatherName = /^[a-zA-Z\u0600-\u06FF\s]+$/
      if (this.fatherName === '') {
        this.fatherError = this.$t('reserveNumber.Name')
        return false
      } else if (fatherName.test(this.fatherName) === false) {
        this.fatherError = this.$t('reserveNumber.NameValid')
      } else {
        this.fatherError = ''
        return true
      }
    },
    emailValidation () {
      const emailReg = /^\S+@\S+\.\S+$/
      if (this.email === '') {
        this.emailError = this.$t('feedBack.validation.required.email')
        return false
      } else if (emailReg.test(this.email) === false) {
        this.emailError = this.$t('feedBack.validation.invalid.email')
        return false
      } else {
        this.emailError = ''
        return true
      }
    },
    mobileValidation () {
      const mobileReg = /^[0][9][0-9]{8}$/
      if (this.mobile === '') {
        this.mobileError = this.$t('feedBack.validation.required.mobileNumber')
        return false
      } else if (mobileReg.test(this.mobile) === false) {
        this.mobileError = this.$t('feedBack.validation.invalid.mobileNumber')
        return false
      } else {
        this.mobileError = ''
        return true
      }
    },
    cityValidation () {
      if (this.selectedCity === null) {
        this.cityError = this.$t('reserveNumber.city')
        return false
      } else {
        this.cityError = ''
        return true
      }
    },
    getId () {
      this.cityId = this.selectedCity.code
    },
    birthdateValidation () {
      if (this.date === null) {
        this.dateError = this.$t('reserveNumber.birth')
        return false
      } else {
        const date = this.date
        const newDate = addDays(date, 1)
        const finalDate = newDate.toISOString().slice(0, 10)
        this.finalDate = finalDate
        this.dateError = ''
        return true
      }
    },
    async submit () {
      this.submited = true
      this.nameValidation()
      this.familyValidation()
      this.fatherValidation()
      this.emailValidation()
      this.mobileValidation()
      this.cityValidation()
      this.birthdateValidation()
      if (this.nameValidation() && this.familyValidation() && this.fatherValidation() && this.emailValidation() && this.mobileValidation() && this.cityValidation() && this.birthdateValidation()) {
        this.isLoading = true
        $('.yellow-button').prop('disabled', true)
        try {
          const formData = new FormData()
          formData.append('phoneNumber', this.mobile)
          formData.append('cityId', this.cityId)
          formData.append('cityName', this.selectedCity.name)
          formData.append('email', this.email)
          formData.append('birthDate', this.finalDate)
          formData.append('lineType', this.lineType)
          formData.append('firstName', this.firstName)
          formData.append('fatherName', this.fatherName)
          formData.append('lastName', this.familyName)
          formData.append('reservedNumber', this.numberReserved)
          const response = await this.reserve.post(formData)
          if (response.data.status === 200) {
            ms.successMessage(response.data.message)
            this.isLoading = false
            $('.yellow-button').prop('disabled', false)
            $('.FeedbackIcon').removeClass('selected')
            this.mobile = ''
            this.cityId = ''
            this.email = ''
            this.finalDate = ''
            this.firstName = ''
            this.fatherName = ''
            this.familyName = ''
            this.selectedCity = null
            this.date = null
            this.$router.push('/reserve-number')
          } else {
            ms.errorMessage(response.data.message)
            this.isLoading = false
            $('.yellow-button').prop('disabled', false)
          }
        } catch (e) {
          try {
            if (e.response.data) {
              ms.errorMessage(e.response.data.message)
              this.isLoading = false
              $('.yellow-button').prop('disabled', false)
            }
          } catch {
            ms.errorMessage(e.response.data.message)
            this.isLoading = false
            $('.yellow-button').prop('disabled', false)
          }
        }
      }
    }
  }
}
</script>

<style  scoped lang="scss">
  @import "src/assets/sass/main";
  @import "~primevue/resources/primevue.min.css";
  @import "~primeicons/primeicons.css";
  #Reservation{
    padding-top: 160px;
  }
  #Reservation .social-nav{
    //background: rgba(212, 212, 212, 0.45);
    //background-color: $--light-white;
    height: 50px;
    //box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;
    background: rgba(242, 242, 242, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
    //backdrop-filter: blur(40px);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }
  .arabicBack{
    right: 4vw;
    left: unset !important;
    transform: rotateY(180deg);
  }
  .arabicSearch{
    right: 0 !important;
    left: unset !important;
  }
  #Reservation .nameContainer{
    display: flex;
    padding: 0 4vw 0 3.2vw;
  }
  #Reservation .homeIcon {
    cursor: pointer;
  }
  .homeIcon,
  .arrowIcon,
  .titleName{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  #Reservation .titleName{
    width: max-content;
    color: $--yellow;
    font-family: Mtn-bold;
    text-decoration: underline;
  }
  .mainContiner, .background {
    min-height: 550px;
  }
  .mainContiner {
    background-image: linear-gradient(to bottom, #ebebeb, #E1E1E1);
    position: relative;
  }
  .background {
    background-image: url("../../assets/icons/reservationDetails.svg");
    background-position-y: 130%;
  }
  .NumberReserved {
    padding: 25px 5vw 0px 5vw;
  }
  /*.reserveTitle{*/
  /*  padding-right: 25px;*/
  /*}*/
  .description {
    /*padding-top: 25px;*/
    padding: 25px 20px 25px 25px;
  }
  .formContainer{
    padding: 0px 0 30px 0;
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;
  }
  .formImage {
    height: 600px;
    width: 730px;
    position: relative;
    z-index: 100
  }
  .form{
    position: absolute;
    top: 25px;
    left: 0px;
    width: 100%;
    height: 30%;
    border-radius: 15px;
    padding: 40px 60px;
    z-index: 300
  }
  .yellowBorder {
    border: 2px #FFCB05 solid;
    border-radius: 13px;
    height: 50px;
    padding: 0px 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  #Reservation .yellow-button {
    pointer-events: all !important;
    cursor: pointer;
    width: 95px;
    height: 95px;
    background: #FFCB05;
    position: absolute;
    border-radius: 100px;
    transition: all 0.3s ease-in-out;
    z-index: 200;
    right: 113px;
    bottom: 35px;
  }
  .number {
    color: #FFCB05;
    font-family: 'Mtn-bold';
    font-style: italic;
    font-size: 20px;
  }
  .reserveTitle {
    font-size: 20px;
  }
  .numberPrice{
    color: #FFCB05;
    font-family: 'Mtn-bold';
    font-style: italic;
    font-size: 20px;
  }
  .mtnBack{
    position: absolute;
    top: 30px;
    padding: 0 4vw;
    z-index: 100
  }
  #Reservation .form input {
    width: 100%;
  }
  #Reservation .form input::placeholder {
    width: 100%;
    color: #1D1D1D;
    font-family: Mtn-bold;
  }
  .labelDate{
    color: #1D1D1D;
    font-family: Mtn-bold;
  }
  .validationMargin{
    margin-bottom: -15px;
  }
  .validationMessage{
    display: flex;
    font-size: 11px;
    padding: 0 15px;
    color: red;
    height: 15px
  }
  .arabicPlaceholder::-webkit-input-placeholder {
   font-family: Mtn-arabic-bold !important;
  }
  /*--------------------------- form resopnsive -------------------------------*/
  @media screen and (max-width: 800px) {
    .formImage{
      width: 650px;
    }
    .form {
      top: 33px;
    }
    #Reservation .yellow-button {
      width: 90px;
      height: 90px;
      right: 97px;
      bottom: 62px;
    }
  }
  @media screen and (max-width: 730px) {
    .formImage{
      width: 570px;
      height: 640px;
    }
    .form {
      top: 80px;
      padding: 40px 55px;
    }
    .yellowBorder{
      height: 40px;
    }
    #Reservation .yellow-button {
      width: 75px;
      height: 75px;
      right: 88px;
      bottom: 115px;
    }
  }
  @media screen and (max-width: 630px) {
    .formImage{
      width: 500px;
      height: 670px;
      margin-bottom: -145px;
      margin-top: -55px;
    }
    .form {
      top: 56px;
      padding: 40px 55px;
    }
    .yellowBorder{
      height: 35px;
    }
    #Reservation .yellow-button {
      width: 70px;
      height: 70px;
      right: 73px;
      bottom: 205px;
    }
  }
  .smallForm {
    display: none;
  }
  @media screen and (max-width: 630px) {
    .bigForm{
      display: none;
    }
    .smallForm {
      display: block;
    }
    .formImage{
      margin-top: unset;
      margin-bottom: unset;
    }
    .yellowBorder{
      height: 55px;
    }
    .form {
      padding: 0px 65px;
    }
    #Reservation .yellow-button {
      width: 90px;
      height: 90px;
      right: 120px;
      bottom: 20px;
    }
    //.mtnBack{
    //  display: none;
    //}
 }
  @media screen and (max-width: 470px) {
    .formImage {
      width: 370px
    }
    .form {
      padding: 40px 30px;
    }
    #Reservation .yellow-button {
      width: 80px;
      height: 80px;
      right: 71px;
      bottom: 60px;
    }
    .yellowBorder{
      height: 45px;
      padding: 0 15px;
    }
  }
  @media screen and (max-width: 405px) {
    .formImage {
      width: 335px;
      height: 720px;
      margin-bottom: -85px;
    }
    #Reservation .yellow-button {
      width: 70px;
      height: 70px;
      right: 65px;
      bottom: 108px;
    }
    .form {
      padding: 60px 30px;
    }
    .validationMessage {
      font-size: 10px;
    }
    .formContainer{
      margin-top: -85px;
    }
  }
  .yellow-button .read-more {
    right: calc(50% - 18px);
  }
</style>
<style lang="scss">
  /*----------------------------- select style ---------------------------------*/
  #Reservation {

  .p-dropdown {
    width: 100%
  }

  .p-inputtext {
    display: flex !important;
  }

  .p-dropdown-items {
    padding-left: 0 !important;
  }

  .p-dropdown-panel {
    background: white;
    border-radius: 12px;
  }

  .p-dropdown-item {
    padding: 10px 0;
  }

  .p-placeholder {
    color: #1D1D1D;
    font-family: Mtn-bold;
  }

  .pi {
    color: #1D1D1D;
  }

  .p-calendar {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .p-datepicker-group-container {
    width: 300px;
    background: white;
    border-radius: 15px;
    padding: 20px;
  }
  .p-yearpicker, .p-monthpicker {
    width: 300px;
    background: white;
    border-radius: 0 0 15px 15px;
    padding: 15px;
    margin-top: -15px;
  }
  .p-calendar .p-datepicker{
    min-width: 300px;
  }
  .p-datepicker-header {
    padding-bottom: 10px;
  }
  .p-calendar .p-inputtext{
    cursor: pointer;
    position: relative;
    z-index: 100;
  }
  .p-datepicker tr{
    height: 30px;
  }
  .p-datepicker tr td{
    height: 30px;
    width: 30px;
  }
  .p-datepicker .p-highlight{
    border: 2px #FFCB05 solid;
    border-radius: 30px;
    height: 30px;
    width: 30px;
  }
  .p-monthpicker .p-highlight{
    border: none;
    /*border-radius: 30px;*/
    height: unset;
    width: 33.3%;
  }
  .p-yearpicker .p-highlight{
    border: none;
    /*border-radius: 30px;*/
    height: unset;
    width: 50%;
  }
  .p-datepicker-prev, .p-datepicker-next{
    border: 2px #FFCB05 solid;
    border-radius: 50px;
    height: 30px;
    width: 30px;
  }
  .p-monthpicker-month, .p-yearpicker-year {
    height: 30px;
  }
   .p-link{
    padding: 0 10px
  }
  .p-calendar{
    direction: ltr !important;
  }
  .p-disabled{
    opacity: 0.5
  }
  }
  @media screen and (max-width: 470px) {
    .p-dropdown-panel {
      left: -15px !important;
      top: 25px !important;
      min-width: 125px !important;
    }
    .p-datepicker-group-container,.p-yearpicker, .p-monthpicker {
      width: 225px !important;
    }
    .p-calendar .p-datepicker {
      min-width: 200px !important;
    }
  }

  .arabicDir .p-datepicker {
    right: 0 !important;
    left: unset !important;
  }
  .enDir .p-datepicker {
    right: unset !important;
    left: 0 !important;
  }
  .arabicDir .p-inputtext{
    direction: rtl !important;
  }
  .back {
    width: 38px;
  }
  @media screen and (max-width: 400px) {
    .back {
      width: 28px;
    }
  }
  @media screen and (max-width: 470px) {
    .arabicDir .p-datepicker {
      right: 0 !important;
      left: -100px !important;
    }
  }
</style>
